import InfoIcon from "@material-ui/icons/Info";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import { IRoute } from "src/common/typings/routes";
import { Management } from "./Management";
import { InspectionScanner } from "./pages/InspectionScanner";
import { InspectionWeight } from "./pages/InspectionWeight";
import { ListVehicles } from "./pages/ListVehicles";
import { SecondaryInspection } from "./pages/SecondaryInspection";
import { ListContainers } from "./pages/ListContainers";

export const VehicleManagementRoute: IRoute = {
  title: "Vehicles",
  path: "/nod/vehicle-management",
  icon: LocalShippingIcon,
  component: Management,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: ListVehicles, path: "/list-vehicles", title: "List of Vehicles" },
    {
      icon: InfoIcon,
      component: ListContainers,
      path: "/list-containers",
      title: "List of Containers",
    },
    {
      icon: InfoIcon,
      component: InspectionScanner,
      path: "/inspection-scanner",
      title: "Vehicle Inspection Scanner",
    },
    {
      icon: InfoIcon,
      component: InspectionWeight,
      path: "/inspection-weight",
      title: "Vehicle Inspection Weight",
    },
    {
      icon: InfoIcon,
      component: SecondaryInspection,
      path: "/secondary-inspection",
      title: "Secondary Inspection",
    },
  ],
};
